import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/cn";
import type { Metric } from "@/api/types";

const OPTIONS: { value: Metric; label: string }[] = [
  { value: "messages", label: "Mensajes" },
  { value: "conversations", label: "Conversaciones" },
  { value: "credits", label: "Créditos" },
  { value: "active_days", label: "Días activos" },
];

export interface MetricRadioProps {
  value: Metric;
  onChange: (v: Metric) => void;
}

export function MetricRadio({ value, onChange }: MetricRadioProps) {
  const reduced = useReducedMotion();
  return (
    <div
      role="radiogroup"
      aria-label="Ordenar por"
      className="inline-flex gap-1 rounded-full border border-border-1 bg-white/[0.03] p-1"
    >
      {OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              "relative rounded-full px-3.5 py-1.5 text-sm font-semibold transition-colors",
              active ? "text-white" : "text-text-3 hover:text-text-1",
            )}
          >
            {active && (
              <motion.span
                layoutId="active-metric"
                aria-hidden
                className="absolute inset-0 -z-0 rounded-full bg-gradient-to-br from-brand-1 to-brand-3 shadow-[0_8px_24px_-8px_rgba(236,72,153,0.5)]"
                transition={
                  reduced
                    ? { duration: 0 }
                    : { type: "spring", stiffness: 420, damping: 32 }
                }
              />
            )}
            <span className="relative z-10">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
